import { ref } from 'vue'

import { normalizeDateOnly } from '@/utils/dateUtils'

function createInitialFilters() {
    return {
        adminAccepted: null,
        isSolved: true,
        showMine: null,
        lastAssignee: null,

        machine: null,
        machine__productionDepartment_id: null,
        softwareType: null,
        accidentStatus: null,
        accidentDepartmentIds: null,
        createdAt__gte: null,
        createdAt__lte: null,
        accidentType: null,
        solvedAt__gte: null,
        solvedAt__lte: null,
        costCenterNumber__number: null
    }
}

function createInitialDashboardFilters() {
    const now = new Date()
    const monthStart = new Date(now.getFullYear(), now.getMonth(), 1)

    return {
        machine: [],
        createdAt__gte: normalizeDateOnly(monthStart),
        createdAt__lte: normalizeDateOnly(now),
        orderBy: null
    }
}

export function createMaintenanceAccidentsState() {
    return {
        accidents: ref([]),
        accidentsLoading: ref(false),

        accident: ref(null),
        accidentLoading: ref(false),

        accidentTypes: ref([]),
        softwareTypes: ref([]),
        machinesBasicData: ref([]),
        costCenterNumbers: ref([]),
        accidentStatuses: ref([]),
        accidentDepartments: ref([]),
        accidentUserDepartments: ref([]),

        accidentStatusHistory: ref([]),

        filters: ref(createInitialFilters()),
        createInitialFilters,

        accidentDashboardItems: ref([]),
        accidentDashboardLoading: ref(false),
        accidentDashboardMachines: ref([]),
        accidentDashboardMachinesLoading: ref(false),
        dashboardFilters: ref(createInitialDashboardFilters()),
        createInitialDashboardFilters
    }
}
